import logo from "./logo.svg";
import instagramLogo from "./instagram.svg";
import facebookLogo from "./facebook.svg";

export default {
  logo,
  instagramLogo,
  facebookLogo,
};
